import { toggleExcludeDateFacetValue, toggleSelectDateFacetValue, updateDateFacetValues, } from '../../../../../features/commerce/facets/date-facet/date-facet-actions.js';
import { buildDateRange } from '../../../../core/facets/range-facet/date-facet/date-range.js';
import { buildCoreCommerceFacet, } from '../headless-core-commerce-facet.js';
export { buildDateRange };
/**
 * @internal
 *
 * **Important:** This initializer is meant for internal use by headless only.
 * As an implementer, you must not import or use this initializer directly in your code.
 * You will instead interact with `DateFacet` sub-controller instances through the state of a `FacetGenerator`
 * sub-controller.
 *
 * @param engine - The headless commerce engine.
 * @param options - The `DateFacet` options used internally.
 * @returns A `DateFacet` sub-controller instance.
 */
export function buildCommerceDateFacet(engine, options) {
    const coreController = buildCoreCommerceFacet(engine, {
        options: {
            ...options,
            toggleSelectActionCreator: toggleSelectDateFacetValue,
            toggleExcludeActionCreator: toggleExcludeDateFacetValue,
        },
    });
    const { dispatch } = engine;
    const { facetId, fetchProductsActionCreator } = options;
    return {
        ...coreController,
        setRanges(ranges) {
            dispatch(updateDateFacetValues({
                facetId,
                values: ranges.map((range) => ({ ...range, numberOfResults: 0 })),
            }));
            dispatch(fetchProductsActionCreator());
        },
        get state() {
            return getDateFacetState(coreController.state);
        },
        type: 'dateRange',
    };
}
export const getDateFacetState = (coreState) => {
    return {
        ...coreState,
        type: 'dateRange',
    };
};
